/**
 * @type {Window & {web3: import("web3").default}}
 */
// eslint-disable-next-line no-undef
const _window = typeof window !== "undefined" ? window : {};

export default _window;
